import { Colors } from '..';
import generateGradient from './generateGradient';

const indigo = {
  conical: generateGradient(
    [Colors.Indigo[600], Colors.Indigo[25]],
    'conical',
    {},
    {
      originDeg: 259.08,
      originX: 50,
      originY: 50,
      deg: [0, 360],
    }
  ),
  linear01: generateGradient(
    [Colors.Indigo[600], Colors.Indigo[500]],
    'linear',
    {
      originDeg: 90,
      percent: [0, 100],
    }
  ),
  linear02: generateGradient(
    [Colors.Indigo[700], Colors.Indigo[600]],
    'linear',
    {
      originDeg: 45,
      percent: [0, 100],
    }
  ),
  linear03: generateGradient(
    [Colors.Indigo[800], Colors.Indigo[600]],
    'linear',
    {
      originDeg: 45,
      percent: [0, 100],
    }
  ),
  linear04: generateGradient(
    [Colors.Indigo[800], Colors.Indigo[600]],
    'linear',
    {
      originDeg: 90,
      percent: [0, 100],
    }
  ),
  linear05: generateGradient(
    [Colors.Indigo[800], Colors.Indigo[700]],
    'linear',
    {
      originDeg: 26.5,
      percent: [0, 100],
    }
  ),
  linear06: generateGradient(
    [Colors.Indigo[900], Colors.Indigo[600]],
    'linear',
    {
      originDeg: 45,
      percent: [0, 100],
    }
  ),
} as const;

export default indigo;
